<template>
	<section class='leaveStu'>

		<Row xs="20" sm="16" md="12" lg="8">

			<Col span='4'>
				<Input v-model="searchParam.name" placeholder="标题" />
			</Col>

			<Col span='1'>
				<Button type="info" @click='searchData'>查询</Button>
			</Col>
			<ul class='conheadRight'>
				<i-button type="error" @click='sModal(-1)'>发布商品</i-button>
			</ul>
		</Row>
		<section class='tabelContent'>
			<tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'></tablePage>
		</section>


		<bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
	</section>
</template>

<script>
	import getDates from '../utils/index'
	import tablePage from './tablePage'
	import bemodal from './formItemNoSch'
	export default {
		name: 'goodslist',
		components: {
			tablePage,
			bemodal,
		},
		data() {
			return {
				smodal: false,
				reloadTmep: -1,
				initformData:[],
				formData: [
					['goods/getId.do', 'goods/save.do','goods/delete.do'],
					[
            {
            	type: 'input',
            	title: '商品名称',
            	name: 'goodname',
            	model: '',
               block:true,
            },
            {
            	type: 'input',
            	title: '商品编号',
            	name: 'goodno',
            	model: '',
              block:true,
            },
            {
            	type: 'numberInput',
            	title: '商品金额',
            	name: 'amount',
            	model: 0,
               block:true,
            },
            {
            	type: 'numberInput',
            	title: '商品原价',
            	name: 'oldamount',
            	model: 0,
              block:true,
            },
            {
            	type: 'numberInput',
            	title: '商品数量',
            	name: 'num',
            	model: 0,
              block:true,
            },
            {
            	type: 'numberInput',
            	title: '限购数量',
            	name: 'limitnum',
            	model: 10,
              block:true,
            },
            // {
            // 	type: 'switch',
            // 	title: '是否电子券',
            // 	name: 'isquan',
            // 	model: true,
            //    block:true,
            // },
            {
            	type: 'textarea',
            	title: '商品描述',
            	name: 'gooddesc',
            	model: ''
            },

            {
            	type: 'textarea',
            	title: '提货地点',
            	name: 'address',
            	model: ''
            },
            {
            	type: 'uploadimg',
            	title: '商品图片',
            	name: 'pic',
                pictype:{type:'gallery',size:'正方形 1:1'},
            	model: '',
              len:5,
            },
						{
							type: 'hidden',
							children: [{
								name: 'guid',
								model: ''
							},{
                name:'isquan',
                model:1
              }]
						}
					]
				],
				queryData: ['goods/getQueryList.do?isquan=1&isshow=-1',
					[{
							title: '商品编号',
							key: 'goodno',
              width: 100,
						},
						{
							title: '商品名称',
							key: 'goodname',
							align: 'center',
              render: (h, params) => {
              	return h('span', decodeURI(params.row.goodname))
              }
						},
						{
							title: '商品价格',
							key: 'amount',
							width: 120,
							align: 'center',
						},
						{
							title: '售出数量',
							key: 'salenum',
							width: 100,
							align: 'center',
						},
            {
							title: '库存',
							key: 'num',
							width: 100,
							align: 'center',
						},
						{
							title: '进账金额（元）',
							key: 'saleamount',
							width: 120,
							align: 'center',
						},
            {
            	title: '进账积分',
            	key: 'salewjscore',
            	width: 100,
            	align: 'center',
            },
            {
            	title: '商品状态',
            	key: 'isshow',
            	width: 100,
            	align: 'center',
              render: (h, params) => {
                var _state =  params.row.isshow == 0 ? "已下架" : "上架中"
              
                if (params.row.isshow !=0) {
									return h('span', {
										style: {
											color: " #00d186",
                     
										},
									}, _state)
								} else {
									return h('span', _state)
								}
              }
            },
            {
            	title: '提货地点',
            	key: 'address',
            	align: 'center',
            },
           
            {
              title: '操作',
              slot: 'action',
              width: 90,
              align: 'center',
              render: (h, params) => {
                  var that = this
                  var _state = params.row.isshow == 1 ? '下架' : '上架'
                  
                  var _newSate = params.row.isshow == 0 ? '上架':'下架'
                  var _newdel =  params.row.isshow == 0 ? 1 : 0
                  return h('div', [
                                h('Dropdown',{
                                   props:{
                                    trigger:"click"
                                  },
                                  on:{
                                    'on-click':(value)=>{
                                      ////console.log(value) //此处的value和下面DropdownMenu选项的name对应
                                       if(value=='submit'){
                                         this.sModal(params.row.guid)
                                       }else if(value=='delete'){
                                          if(params.row.state == 0){
                                              this.$Modal.confirm({
                                                title: '提示',
                                                content: '<p>是否确认【'+_newSate+'】'+params.row.goodname+'？</p>',
                                                onOk: () => {
                                                  that.axios.post('goods/saveShow', {
                                                    id: params.row.guid,
                                                    isshow:_newdel
                                                  }).then(res => {
                                                    ////console.log(res)
                                                    that.$Message.success(res.msg)

                                                    that.reloadTable()


                                                  })
                                                },
                                                onCancel: () => {

                                                }
                                              });
                                             

                                          }else{
                                            this.$Modal.confirm({
                                              title: '提示',
                                              content: '<p>是否确认【'+_newSate+'】'+params.row.goodname+'？</p>',
                                              onOk: () => {
                                                that.axios.post('goods/saveShow', {
                                                  id: params.row.guid,
                                                  isshow:_newdel
                                                }).then(res => {

                                                  that.$Message.success(res.msg)
                                                  that.reloadTable()
                                                }).catch(function(res) {
                                                  that.$Message.error('系统异常')
                                                })
                                              },
                                              onCancel: () => {

                                              }
                                            });
                                          }


                                       }
                                    }
                                  }
                                },[
                                  h('span',{
                                        style: {
                                          display: 'inline-block',
                                          width: '60px',
                                          height: '25px',
                                          background: '#2db7f5',
                                          borderRadius: '6px',
                                          textAlign: 'center',
                                          lineHeight: '25px',
                                          color: '#fff',
                                          fontSize: '12px',
                                          cursor: 'pointer',
                                          userSelect: 'none'
                                        }},[
                                       h('span','操作'),
                                      h('Icon',{
                                        props:{
                                          type: 'md-arrow-dropdown'
                                        }
                                      })
                                    ]),
                                    h('DropdownMenu',{
                                      slot:'list'
                                    },[
                                      h('DropdownItem',{
                                        props:{
                                          name: 'submit'
                                        }
                                      },'编辑'),
                                     
                                      h('DropdownItem',{
                                        props:{
                                          name: 'delete'
                                        }
                                      },_state),
                                      
                                   ])
                                ])
                              ])



              }
            }
					]
				],
				searchParam: {
					name:'',
				},
				issearch: -1,
			}
		},
		mounted(){
			this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
		},
		methods: {
			searchData() {
				this.issearch = Math.random()
			},
			sModal(guid) {
				console.log(guid, 'guid', this.formData[0][0])
				this.reloadTmep = Math.random()
				if (this.formData[0][0].indexOf('?') > -1) {
					this.formData[0][0] = this.formData[0][0].split('?')[0]
				}
				this.formData[0][0] = this.formData[0][0] + '?id=' + guid
				if(guid == -1){
					this.formData[1] =JSON.parse(JSON.stringify(this.initformData))
				}
			},
			reloadTable() {
				this.issearch = Math.random()
			}
		}
	}
</script>

<style scoped>
	.tabelContent {
		margin-top: 20px;
	}
	.leaveStu{
		flex:1;
		padding-right:25px!important;
		/* overflow: scroll; */
		padding-bottom:50px;
		padding-top:20px;
		overflow-x:hidden;
	}
	.leaveStu .ivu-row:first-of-type {
		margin-top: 5px;
	}

	.leaveStu .ivu-row {
		margin-top: 20px;
		/* 	overflow:hidden; */
		position: relative;
	}

	.leaveStu .ivu-col {
		margin-right: 10px;
		/* float:left; */
	}

	.leaveStu .ivu-col:last-of-type {
		float: left;
		margin-left: 10px;
		/* position:absolute;
		right:0px; */
	}

	.demo-upload-list {



		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		overflow: hidden;
		margin-right: 4px;
		margin-bottom: 5px;
	}

	.demo-upload-list img {
		width: 40px;
		height: 40px;
		float: left;
		margin-right: 15px;
	}

	.demo-upload-list span {
		line-height: 40px;
		font-size: 12px;
		float: left;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 10px;
		line-height: 40px;

	}

	#hwSchool {
		position: relative;
	}

	#hwSchool .ivu-tree {
		position: absolute;
		top: 33px;
		left: 0px;
		background: #fff;
		z-index: 1000;
		width: 300px;
		height: 300px;
		border: 1px solid #dcdee2;
		border-top: 0 none;
		overflow-y: scroll;
		overflow-x: hidden;
		padding-left: 10px;
	}

	.modalUl {
		width: 100%;
		display: flex;
		justify-content: space-between;


	}

	.modalUl li {
		list-style: none;

	}

	.modalUl>li:first-of-type {
		width: 35%;
		height: 100%;
		height: 400px;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.modalUl>li:last-of-type {
		flex: 1;
		padding-left: 30px;
	}

	.treeContent {}

	.hwImgCon {
		margin-top: 10px;

	}

	.hwImgCon img {
		width: 55px;
		height: 55px;
		border-radius: 5px;
	}

	.conheadRight {
		float: right;
	}
</style>
